export const roadMapItems = [
  {
    id: 1,
    number: "1",
    title: "Select Your Training Module",
    description:
      "Start by choosing the specific course or subject matter you want to develop",
    link: "#",
  },
  {
    id: 2,
    number: "2",
    title: "Choose Course",
    description:
      "Input key information like learning objectives, target audience, and format",
    link: "#",
  },
  {
    id: 3,
    number: "3",
    title: "Enroll in course",
    description:
      "Review, edit, and polish your material to ensure it’s learner-friendly and effective",
    link: "#",
  },
  {
    id: 4,
    number: "4",
    title: "Start Learning",
    description:
      "Publish your course and start delivering valuable education to your learners",
    link: "#",
  },
];
